import { useLocation } from "@tanstack/react-router";
import { formatPageDate, getPageDate } from "@/data/page-dates";

/** Shared visible "Last updated" line; date comes only from src/data/page-dates.ts. */
export function LastUpdated({ suffix, className = "mt-4" }: { suffix?: string; className?: string }) {
  const { pathname } = useLocation();
  const date = getPageDate(pathname);
  if (!date) return null;
  return (
    <p className={`${className} text-[13px] leading-snug opacity-70`}>
      Last updated: <time dateTime={date.updatedAt}>{formatPageDate(date.updatedAt)}</time>
      {suffix}
    </p>
  );
}
